import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

function Load() {
  const alien1 = useRef();
  const alien2 = useRef();
  const alien3 = useRef();
  const pupil1 = useRef();
  const pupil2 = useRef();
  const pupil3 = useRef();

  useEffect(() => {
    let tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 0.2,
      yoyo: true,
      yoyoEase: "bounce",
    });
    tl.fromTo(
      alien1.current,
      { y: "-60" },
      {
        x: "220",
        y: "0",
        duration: "0.2",
      }
    );
    tl.to(alien2.current, {
      x: "220",
      y: "-2",
      duration: "0.2",
    });
    tl.to(alien3.current, {
      x: "220",
      y: "-60",
      duration: "0.2",
    });
    gsap.to(pupil1.current, {
      rotation: "-90",
      repeat: "-1",
      duration: "3",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(pupil2.current, {
      rotation: "45",
      repeat: "-1",
      duration: "3",
      ease: "bounce",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(pupil3.current, {
      rotation: "-90",
      repeat: "-1",
      duration: "2",
      ease: "power4",
      yoyoEase: true,
      yoyo: true,
    });
  });

  return (
    <>
      <svg
        width="600"
        height="100"
        viewBox="0 0 1014 552"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="load">
          <g id="alien1" ref={alien1}>
            <path
              id="Vector"
              d="M128 513C171.63 513 207 477.63 207 434C207 390.37 171.63 355 128 355C84.3695 355 49 390.37 49 434C49 477.63 84.3695 513 128 513Z"
              fill="#39FF14"
            />
            <path id="Vector_2" d="M116 496H92V539H116V496Z" fill="#39FF14" />
            <path id="Vector_3" d="M164 496H140V539H164V496Z" fill="#39FF14" />
            <path
              id="Vector_4"
              d="M112 547C123.046 547 132 543.642 132 539.5C132 535.358 123.046 532 112 532C100.954 532 92 535.358 92 539.5C92 543.642 100.954 547 112 547Z"
              fill="#39FF14"
            />
            <path
              id="Vector_5"
              d="M160 546C171.046 546 180 542.642 180 538.5C180 534.358 171.046 531 160 531C148.954 531 140 534.358 140 538.5C140 542.642 148.954 546 160 546Z"
              fill="#39FF14"
            />
            <path
              id="Vector_6"
              d="M130 441C144.912 441 157 428.912 157 414C157 399.088 144.912 387 130 387C115.088 387 103 399.088 103 414C103 428.912 115.088 441 130 441Z"
              fill="white"
            />
            <path
              id="pupil1"
              d="M130 423C134.971 423 139 418.971 139 414C139 409.029 134.971 405 130 405C125.029 405 121 409.029 121 414C121 418.971 125.029 423 130 423Z"
              fill="#3F3D56"
              ref={pupil1}
            />
            <path
              id="Vector_7"
              d="M51.3673 360.532C44.9884 331.965 65.3792 303.098 96.9113 296.057C128.443 289.017 159.176 306.467 165.555 335.035C171.934 363.603 151.037 374.139 119.505 381.18C87.9724 388.221 57.7462 389.1 51.3673 360.532Z"
              fill="#3F3D56"
            />
          </g>
          <g id="alien3" ref={alien3}>
            <path
              id="Vector_8"
              d="M879 513C922.63 513 958 477.63 958 434C958 390.37 922.63 355 879 355C835.37 355 800 390.37 800 434C800 477.63 835.37 513 879 513Z"
              fill="#39FF14"
            />
            <path id="Vector_9" d="M867 496H843V539H867V496Z" fill="#39FF14" />
            <path id="Vector_10" d="M915 496H891V539H915V496Z" fill="#39FF14" />
            <path
              id="Vector_11"
              d="M863 547C874.046 547 883 543.642 883 539.5C883 535.358 874.046 532 863 532C851.954 532 843 535.358 843 539.5C843 543.642 851.954 547 863 547Z"
              fill="#39FF14"
            />
            <path
              id="Vector_12"
              d="M911 546C922.046 546 931 542.642 931 538.5C931 534.358 922.046 531 911 531C899.954 531 891 534.358 891 538.5C891 542.642 899.954 546 911 546Z"
              fill="#39FF14"
            />
            <path
              id="Vector_13"
              d="M881 441C895.912 441 908 428.912 908 414C908 399.088 895.912 387 881 387C866.088 387 854 399.088 854 414C854 428.912 866.088 441 881 441Z"
              fill="white"
            />
            <path
              id="pupil3"
              d="M881 423C885.971 423 890 418.971 890 414C890 409.029 885.971 405 881 405C876.029 405 872 409.029 872 414C872 418.971 876.029 423 881 423Z"
              fill="#3F3D56"
              ref={pupil3}
            />
            <path
              id="Vector_14"
              d="M802.367 360.532C795.988 331.965 816.379 303.098 847.911 296.057C879.443 289.017 910.176 306.467 916.555 335.035C922.934 363.603 902.037 374.139 870.505 381.18C838.972 388.221 808.746 389.1 802.367 360.532Z"
              fill="#39FF14"
            />
          </g>
          <g id="alien2" ref={alien2}>
            <path
              id="Vector_15"
              d="M507 513C550.63 513 586 477.63 586 434C586 390.37 550.63 355 507 355C463.37 355 428 390.37 428 434C428 477.63 463.37 513 507 513Z"
              fill="#39FF14"
            />
            <path id="Vector_16" d="M495 496H471V539H495V496Z" fill="#39FF14" />
            <path id="Vector_17" d="M543 496H519V539H543V496Z" fill="#39FF14" />
            <path
              id="Vector_18"
              d="M491 547C502.046 547 511 543.642 511 539.5C511 535.358 502.046 532 491 532C479.954 532 471 535.358 471 539.5C471 543.642 479.954 547 491 547Z"
              fill="#39FF14"
            />
            <path
              id="Vector_19"
              d="M539 546C550.046 546 559 542.642 559 538.5C559 534.358 550.046 531 539 531C527.954 531 519 534.358 519 538.5C519 542.642 527.954 546 539 546Z"
              fill="#39FF14"
            />
            <path
              id="Vector_20"
              d="M509 441C523.912 441 536 428.912 536 414C536 399.088 523.912 387 509 387C494.088 387 482 399.088 482 414C482 428.912 494.088 441 509 441Z"
              fill="white"
            />
            <path
              id="pupil2"
              d="M509 423C513.971 423 518 418.971 518 414C518 409.029 513.971 405 509 405C504.029 405 500 409.029 500 414C500 418.971 504.029 423 509 423Z"
              fill="#3F3D56"
              ref={pupil2}
            />
            <path
              id="Vector_21"
              d="M430.367 360.532C423.988 331.965 444.379 303.098 475.911 296.057C507.443 289.017 510.621 306.432 517 335C523.379 363.568 530.037 374.139 498.505 381.18C466.972 388.221 436.746 389.1 430.367 360.532Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_22"
              d="M544.555 335.035C538.183 306.497 507.507 289.055 476.01 296.038L497.983 381.293C498.157 381.255 498.33 381.219 498.505 381.18C530.037 374.139 550.934 363.603 544.555 335.035Z"
              fill="#39FF14"
            />
          </g>
        </g>
      </svg>
    </>
  );
}

export default Load;
